import { M as c, j as d, U as l, B as u, $ as p } from "./index-BywkImj3.mjs";
import { z as o } from "./index-DGl1HeGK.mjs";
let f = /(-?(?:\d+\.?\d*|\d*\.?\d+)(?:e[-+]?\d+)?)\s*([\p{L}]*)/uig;
e.nanosecond = e.ns = 1 / 1e6;
e.µs = e.μs = e.us = e.microsecond = 1 / 1e3;
e.millisecond = e.ms = e[""] = 1;
e.second = e.sec = e.s = e.ms * 1e3;
e.minute = e.min = e.m = e.s * 60;
e.hour = e.hr = e.h = e.m * 60;
e.day = e.d = e.h * 24;
e.week = e.wk = e.w = e.d * 7;
e.month = e.b = e.d * (365.25 / 12);
e.year = e.yr = e.y = e.d * 365.25;
function e(a = "", s = "ms") {
  var r = null;
  a = (a + "").replace(/(\d)[,_](\d)/g, "$1$2");
  var i = a[0] === "-";
  return a.replace(f, function(g, m, t) {
    t = n(t), t && (r = (r || 0) + Math.abs(parseFloat(m, 10)) * t);
  }), r && r / (n(s) || 1) * (i ? -1 : 1);
}
function n(a) {
  return e[a] || e[a.toLowerCase().replace(/s$/, "")];
}
const w = o.object({
  envName: c,
  preview: d,
  marketId: l,
  languageTag: u,
  rotatingVerifySecret: p.optional(),
  mock: o.union([o.literal("true"), o.literal("false"), o.string(), o.boolean()]).transform(
    (a) => ["true", "false"].includes(a.toString()) ? a === "true" : a
  ).optional()
});
export {
  w as c,
  e as p
};
//# sourceMappingURL=common-query-param-schema-CaKw7HAh.mjs.map
